import { useState, useEffect } from "react";

const TypeWriter = ({ texts, speed = 100 }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isTyped, setIsTyped] = useState(false);

  useEffect(() => {
    const fullText = texts[currentTextIndex];

    if (currentText.length < fullText.length && !isTyped) {
      const timeout = setTimeout(() => {
        setCurrentText(fullText.substring(0, currentText.length + 1));
      }, speed);

      return () => clearTimeout(timeout);
    } else if (!isTyped) {
      // Wait 2 seconds before moving to next text
      const timeout = setTimeout(() => {
        setIsTyped(true);
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        setCurrentText("");
        setIsTyped(false);
      }, 10000);

      return () => clearTimeout(timeout);
    }
  }, [currentText, currentTextIndex, isTyped, texts, speed]);

  return (
    <span className="typewriter">
      {currentText}
      <span className="cursor">|</span>
    </span>
  );
};

export default TypeWriter;
